/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-06-16 11:07:47
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-09-16 14:02:21
 * @FilePath: /unifyxp-v2-store-portal/src/request/link/index.ts
 */
import { LinkModuleParam } from '@/src/types/common/linkType';
import { get, post } from 'src/tools/server';

export const linkList = (params?): Promise<any> => {
  return get(`portal/linkModuleSearch/`, params);
};

export const linkData = (body: LinkModuleParam): Promise<any> => {
  return post(`portal/linkModuleSearch/`, body, {});
};

export const createExternalLink = (body: any) => {
  return post(`portal/linkLibrary/`, body, {});
};
